const loadYouTubeApi = () => {

  let tag = document.createElement('script');

  tag.src = "https://www.youtube.com/iframe_api";
  let firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
};

function onPlayerReady(event) {
  event.target.playVideo();
}

const init = () => {
  const items = document.querySelectorAll('.js-youtube-block');

  if (items.length === 0) return;

  loadYouTubeApi();

  items.forEach(item => {
    const thumbnail = item.querySelector('.js-youtube-thumbnail');
    const playerElement = item.querySelector('.js-youtube-player');

    const videoId = item.getAttribute('data-video-id');
    const playerElementId = playerElement.id;


    const setPlayer = function onYouTubeIframeAPIReady() {
      let player;

      player = new YT.Player(playerElementId, { // eslint-disable-line
        height: '360',
        width: '640',
        videoId: videoId,
        events: {
          'onReady': onPlayerReady,
        }
      });
    };


    const clickHandler = () => {
      thumbnail.style.display = 'none';
      playerElement.style.display = 'block';
      setPlayer();
    };

    thumbnail.addEventListener('click', clickHandler);

  });
};

export default init;
